<cm-three-template-scene-provider [forceWebGl]="false" (onInitialized)="onInititalizedThreeSceneManagerService($event)">
    <!--Structural directives like @if create embedded views, which have a different destruction order than regular projected content.
        Angular destroys embedded views before calling the host component's ngOnDestroy.
        We leverage this here to destroy all children before the cm-three-template-scene-provider.
        This is particularly important for <cm-three-template-scene-viewer> destroying before ThreeSceneManagerService.-->
    @if ($isAlive()) {
        <div class="cm-main-card">
            <div class="cm-title">
                <div class="cm-title-section">
                    <button class="cm-back-icon" (click)="navigateBack()" matTooltip="Back to list">
                        <i class="far fa-chevron-left"></i>
                    </button>
                    <cm-title-section
                        [iconClass]="null"
                        [title]="$title()"
                        [isLoaded]="true"
                        [canEdit]="$allowTitleEdit()"
                        (onChanged)="requestTitleChange.emit($event)"
                    >
                        <div class="cm-title-prefix" cm-pretitle>
                            @if ($preTitle(); as preTitle) {
                                {{ preTitle }}
                            }
                        </div>
                    </cm-title-section>
                    @if ($postTitle(); as postTitle) {
                        <span class="cm-label-text">{{ postTitle }}</span>
                    }
                    <cm-button
                        class="cm-save"
                        (click)="save()"
                        [class.cm-disabled]="!localSceneManagerService.$templateGraphModified()"
                        [class.cm-active]="localSceneManagerService.$templateGraphModified()"
                    >
                        <ng-container cm-left-icon>
                            <i class="far fa-save"></i>
                        </ng-container>
                        <ng-container cm-text> Save</ng-container>
                        <ng-container cm-right-icon>
                            <i class="far fa-caret-down" (click)="$event.stopPropagation(); $event.preventDefault()" [matMenuTriggerFor]="saveDropdownMenu"></i>
                        </ng-container>
                    </cm-button>
                    <mat-menu #saveDropdownMenu>
                        <button mat-menu-item (click)="saveNewRevision()">Save as new revision</button>
                    </mat-menu>
                    <div
                        class="cm-icon-button"
                        (click)="localSceneManagerService.undo()"
                        [class.cm-disabled]="!localSceneManagerService.$canUndo()"
                        matTooltip="Undo Changes"
                    >
                        <i class="far fa-rotate-left"></i>
                    </div>
                    <div
                        class="cm-icon-button"
                        (click)="localSceneManagerService.redo()"
                        [class.cm-disabled]="!localSceneManagerService.$canRedo()"
                        matTooltip="Redo Changes"
                    >
                        <i class="far fa-rotate-right"></i>
                    </div>
                </div>
                @if ($templateViewType() === "edit") {
                    <div class="cm-title-section">
                        <cm-template-add></cm-template-add>
                    </div>
                }
                <div class="cm-title-section">
                    @if ($canChangeViewType()) {
                        <cm-template-view-type-selector
                            [viewType]="$templateViewType()"
                            (viewTypeChanged)="$templateViewType.set($event)"
                        ></cm-template-view-type-selector>
                    }
                </div>
            </div>
            <div class="cm-left-panel-container" [ngStyle]="{width: $leftPanelWidth() + 'px'}">
                <cm-template-tree-view-type-selector
                    [viewType]="$templateTreeViewType()"
                    (viewTypeChanged)="$templateTreeViewType.set($event)"
                    [sceneAggregationMode]="$sceneAggregationMode()"
                    (sceneAggregationModeChanged)="$sceneAggregationMode.set($event)"
                ></cm-template-tree-view-type-selector>
                @switch ($templateTreeViewType()) {
                    @case ("selectVariation") {
                        <cm-template-select-variation></cm-template-select-variation>
                    }
                    @case ("allVariations") {
                        <cm-template-all-variations
                            class="cm-all-variations"
                            [sceneManagerService]="localSceneManagerService"
                            [title]="$title()"
                        ></cm-template-all-variations>
                    }
                    @default {
                        <cm-template-tree
                            class="cm-template-tree"
                            [showSceneNodes]="$templateTreeViewType() === 'performance'"
                            [sceneAggregationMode]="$sceneAggregationMode()"
                        ></cm-template-tree>
                    }
                }
                @if ($templateTreeViewType() === "performance") {
                    <div class="cm-detail">
                        <div class="cm-summary-column">Total:</div>
                        <div class="cm-detail-column">
                            <cm-template-tree-scene-node-aggregation
                                [input]="localSceneManagerService.$scene()"
                                [sceneAggregationMode]="$sceneAggregationMode()"
                            ></cm-template-tree-scene-node-aggregation>
                        </div>
                    </div>
                }
            </div>
            <div class="cm-left-panel-resize-divider" (mousedown)="onLeftPanelDividerMouseDown($event)"></div>
            <div class="cm-inspector-area" [ngStyle]="{width: $inspectorWidth() + 'px'}" cdkScrollable>
                @if ($showSidePanel() && sidePanelService.$portal(); as portal) {
                    <ng-template [cdkPortalOutlet]="portal"></ng-template>
                } @else {
                    <cm-template-inspector #inspector></cm-template-inspector>
                }
            </div>
            <div class="cm-inspector-resize-divider" (mousedown)="onInspectorDividerMouseDown($event)"></div>
            <div class="cm-viewer-section">
                @switch ($templateViewType()) {
                    @case ("edit") {
                        <div class="cm-viewer-container">
                            <cm-template-drop-mesh-files>
                                <cm-three-template-scene-viewer
                                    #threeViewer
                                    [camera]="$camera()"
                                    [cameraMoveModeActive]="$cameraMoveModeActive()"
                                    (cameraViewChanged)="onCameraViewChanged($event)"
                                    [previewImageData]="$previewImageData()"
                                    [overlayPreviewImageData]="$overlayPreviewImageData()"
                                ></cm-three-template-scene-viewer>
                                @if ($cameraMoveModeActive() && $cameraWasMoved()) {
                                    <div class="cm-camera-change-warning">
                                        <i class="far fa-exclamation-triangle"></i>
                                        You are changing the camera
                                    </div>
                                }
                                <cm-template-scene-viewer-options
                                    class="cm-editor-settings-panel"
                                    [selectedCameraId]="$selectedCameraId()"
                                    (selectedCameraIdChanged)="onSelectedCameraIdChanged($event)"
                                    [threeViewer]="threeViewer"
                                    [fileTitle]="$title()"
                                ></cm-template-scene-viewer-options>
                                @if ($numPendingTasks(); as numPendingTasks) {
                                    <div class="cm-progress-panel">
                                        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
                                        {{ numPendingTasks }}
                                        {{ numPendingTasks > 1 ? "Tasks" : "Task" }}
                                        remaining
                                    </div>
                                }
                                @if ($numTilesLoading()) {
                                    <cm-loading-spinner-icon
                                        class="cm-tiles-loading-spinner"
                                        [matTooltip]="'Loading ' + $numTilesLoading() + ' texture tiles'"
                                    ></cm-loading-spinner-icon>
                                }
                            </cm-template-drop-mesh-files>
                        </div>
                    }
                    @case ("image") {
                        <cm-template-image-viewer
                            [sceneManagerService]="localSceneManagerService"
                            [viewType]="$templateTreeViewType()"
                            (viewTypeChanged)="$templateTreeViewType.set($event)"
                            [fileTitle]="$title()"
                        ></cm-template-image-viewer>
                    }
                    @case ("configurator") {
                        <cm-ar-configurator-actions
                            [templateId]="$templateId()"
                            [templateRevisionId]="$templateRevisionId()"
                            [defaultCustomerId]="$defaultCustomerId()"
                            [configuratorUrlParams]="localSceneManagerService.$configuratorUrlParams()"
                            [templateGraph]="localSceneManagerService.$templateGraph()"
                            [parameters]="localSceneManagerService.$instanceParameters()"
                        ></cm-ar-configurator-actions>
                    }
                }
            </div>
        </div>
    }
</cm-three-template-scene-provider>
